module.exports = __webpack_public_path__ + "assets/normal/images/text.56798fc9.png";